export default __webpack_public_path__ + "static/media/paragraphimageleft.553def3b.svg";